<template>
  <div id="app" ref="app">
     <keep-alive>
      <router-view />
    </keep-alive>
      <!-- <router-view  /> -->
  </div>
</template>

<script>
var docEl = document.documentElement;
var clientWidth = window.innerWidth;
if(clientWidth <= 320){
    docEl.style.fontSize = '50px';
}else if(clientWidth >= 640){
    docEl.style.fontSize = '100px';
}else{
    docEl.style.fontSize = 100 * (clientWidth / 640) + 'px';
}
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family:Helvetica Neue ;
  src: url('./assets/css/Helvetica-Neue.ttf');
}
#app {
  font-family: Helvetica Neue;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
.van-toast{
  font-size: 25px !important;
  border-radius: 15px !important;
  line-height: 25px;
}
.van-toast--html, .van-toast--text {
  padding: 20px 44px !important;
  white-space: nowrap;
}
.van-dialog__footer{
  justify-content:center
}
.van-dialog--round-button .van-dialog__cancel, .van-dialog--round-button .van-dialog__confirm{
  height: 63px;
  flex: 0.5;
  font-size: 25px;
}
.van-dialog--round-button{
  height: 300px;
}
.van-dialog--round-button .van-dialog__message{
  font-size: 30px !important;
  font-weight: 700;
  line-height: 56px;
  padding: 37px 88px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue